/* tslint:disable */
/* eslint-disable */
/**
 * ClinicManagement API
 * This is an OpenAPI for the Clinic Management Microservice
 *
 * OpenAPI spec version: 0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BranchContact } from './branch-contact';
import { BranchCoordinate } from './branch-coordinate';
import { EmployeeSignUpEmployeeAvailability } from './employee-sign-up-employee-availability';
import { EmployeeSignUpEmployeeUserAddress } from './employee-sign-up-employee-user-address';
import { ServicesObjectInner } from './services-object-inner';
/**
 * 
 * @export
 * @interface AddBranchRequest
 */
export interface AddBranchRequest {
    /**
     * 
     * @type {string}
     * @memberof AddBranchRequest
     */
    Name: string;
    /**
     * 
     * @type {EmployeeSignUpEmployeeUserAddress}
     * @memberof AddBranchRequest
     */
    Address: EmployeeSignUpEmployeeUserAddress;
    /**
     * 
     * @type {BranchCoordinate}
     * @memberof AddBranchRequest
     */
    Coordinate: BranchCoordinate;
    /**
     * 
     * @type {string}
     * @memberof AddBranchRequest
     */
    Timezone: AddBranchRequestTimezoneEnum;
    /**
     * 
     * @type {EmployeeSignUpEmployeeAvailability}
     * @memberof AddBranchRequest
     */
    Calendar: EmployeeSignUpEmployeeAvailability;
    /**
     * 
     * @type {BranchContact}
     * @memberof AddBranchRequest
     */
    Contact: BranchContact;
    /**
     * 
     * @type {Array<ServicesObjectInner>}
     * @memberof AddBranchRequest
     */
    Services: Array<ServicesObjectInner>;
}

/**
    * @export
    * @enum {string}
    */
export enum AddBranchRequestTimezoneEnum {
    UTC11 = 'UTC-11',
    UTC10 = 'UTC-10',
    UTC9 = 'UTC-9',
    UTC8 = 'UTC-8',
    UTC7 = 'UTC-7',
    UTC6 = 'UTC-6',
    UTC5 = 'UTC-5',
    UTC4 = 'UTC-4',
    UTC3 = 'UTC-3',
    UTC2 = 'UTC-2',
    UTC1 = 'UTC-1',
    UTC = 'UTC',
    UTC1_12 = 'UTC+1',
    UTC2_13 = 'UTC+2',
    UTC3_14 = 'UTC+3',
    UTC4_15 = 'UTC+4',
    UTC5_16 = 'UTC+5',
    UTC6_17 = 'UTC+6',
    UTC7_18 = 'UTC+7',
    UTC8_19 = 'UTC+8',
    UTC9_20 = 'UTC+9',
    UTC10_21 = 'UTC+10',
    UTC11_22 = 'UTC+11',
    UTC12 = 'UTC+12'
}

